<template>
    <div class="piscreen">
       <div class="topBar">
            <div class="home">
                <a href="/"><font-awesome-icon icon="home" /></a>
            </div>
            <div class="home active">
                <a href="/leaderboard"><font-awesome-icon icon="trophy" /></a>
            </div>
            
            <div class="home">
                <a href="/playeroptions"><font-awesome-icon icon="user-cog" /></a>
            </div>

            <div class="home">
                <a href="/playermilestones"><font-awesome-icon icon="user-check" /></a>
            </div>
            
            <div style="flex-grow: 1; text-align: right; padding-right: 16px; margin-top: 8px; color: white">
                <span style="font-size: 1em; font-weight: normal; padding-right: 1px">seizoen</span>
                <h1 style="margin-top: -4px">
                    {{ season.name }}
                </h1>
            </div>
        </div>

        <div class="leaderboard">
            
            <div class="scores">
                <table>
                    <tr v-for="(player) in sortedPlayers" v-if="player.points > 0">
                        <td class="rank"><span>{{ player.rank }}</span></td>
                        <td class="rankIcon">
                            <font-awesome-icon v-if="player.rank == 1 || player.rank == 2 || player.rank == 3" class="trophy" icon="trophy" v-bind:class="{ gold: player.rank == 1, silver: player.rank == 2, bronze: player.rank == 3 }" />
                            <font-awesome-icon v-if="player.rank >= 4 && player.rank <= 10" class="star" icon="star" />
                            
                            <font-awesome-icon v-if="player.rank > 10" class="smile" icon="smile" />
                            <!-- <font-awesome-icon v-if="player.rank > 3" class="star" icon="medal" /> -->

                        </td>
                        
                        <td><span style="display: block; margin-top: -4px;">{{ player.name }}</span><span style="font-size: 0.8em; display: block; margin-top: 0px;">{{ getTitleName(player.title) }}</span></td>
                        <!-- <td><span style="font-weight: bold">{{ player.name }}</span><span> the Destroyer</span></td> -->
                        <td class="points"><span>{{ player.points }}</span></td>

                        <!-- <td class="fade">S</td>
                        <td class="fade">D2</td>
                        <td class="fade">D3</td>
                        <td class="fade">T2</td>
                        <td class="fade">T3</td>
                        <td class="fade">SH</td>
                        <td class="fade">RH</td>
                        <td class="fade">B</td> -->

                    </tr>
                </table>
            </div>

            <div class="seasons">
                <div class="season" v-for="season in seasons" @click="selectedSeason = season" v-bind:class="{ activeSeason: season == selectedSeason }">{{ season.name }}</div>
            </div>





            <div class="rules">
                <p>Puntentelling</p>
                <ul>
                    <li>Je krijgt 1 punt voor elke score die je invult.<br>Shanghai 20 is dus net zoveel waard als Singles 1.</li>
                </ul>
            </div>
            <!-- <table>
                <tr>
                    <td colspan="2">Legenda</td>
                </tr>
                <tr>
                    <td>S</td>
                    <td>Singles</td>
                </tr>
                <tr>
                    <td>D2</td>
                    <td>Doubles (2x)</td>
                </tr>
                <tr>
                    <td>D3</td>
                    <td>Doubles (3x)</td>
                </tr>
                <tr>
                    <td>T2</td>
                    <td>Triples (2x)</td>
                </tr>
                <tr>
                    <td>T3</td>
                    <td>Triples (3x)</td>
                </tr>
                <tr>
                    <td>SH</td>
                    <td>Shanghai</td>
                </tr>
                <tr>
                    <td>RH</td>
                    <td>Robin Hood</td>
                </tr>
                <tr>
                    <td>B</td>
                    <td>Bull</td>
                </tr>
            </table> -->
        </div>

        <!-- <StatusMessage v-if="statusMessage" :message="statusMessage" :category="category"></StatusMessage> -->

        
            
        
    </div>
</template>

<script>

import axios from 'axios'
import StatusMessage from './partials/StatusMessage'


export default {

    name: 'Leaderboard',

    components: {
        // StatusMessage: StatusMessage
    },

    data() {
        return {
            season: {
                id: 0,
                name: ''
            },
            seasons: [],
            selectedSeason: {},
            activeSeasonId: '',

            titles: {
                none: {
                    id: 1,
                    name: 'Geen titel',
                    description: 'Hier begin je mee',
                    unlocked: true,
                    active: false,
                    score: 0,
                    enabled: true
                },
                singles: {
                    id: 2,
                    name: 'The Chosen One',
                    description: 'Gooi alle Singles',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true
                },
                doubles2x: {
                    id: 3,
                    name: 'Placeholder',
                    description: 'Gooi alle Doubles (2x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                doubles3x: {
                    id: 4,
                    name: 'Placeholder',
                    description: 'Gooi alle Doubles (3x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                triples2x: {
                    id: 5,
                    name: 'Placeholder',
                    description: 'Gooi alle Triples (2x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                triples3x: {
                    id: 6,
                    name: 'Placeholder',
                    description: 'Gooi alle Triples (3x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                shanghai: {
                    id: 7,
                    name: 'Shanghai Master',
                    description: 'Gooi alle Shanghais',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true
                },
                robinhood: {
                    id: 8,
                    name: 'The Destroyer',
                    description: 'Gooi alle Robin Hoods',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true
                },
                bull: {
                    id: 9,
                    name: 'Dartkoning',
                    description: 'Gooi 3x de Bullseye in 1 beurt',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true
                },
                all: {
                    id: 10,
                    name: 'Dartrobot',
                    description: 'Gooi alles in alle categorieën',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true
                },
            }

        }
        
    },

    computed: {
        sortedPlayers() {
            
            let sorted = [];

            
            if (this.selectedSeason.players) {
                sorted = this.selectedSeason.players.sort(function(a, b){
                    if (Number(a.points) < Number(b.points)) return 1;
                    if (Number(a.points) > Number(b.points)) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
            }
            
            
            

            return sorted;
        }
    },

    methods: {
        getTitleName(id) {
            let titleName = '';

            for (var key of Object.keys(this.titles)) {
                    
                if (this.titles[key].id == id) {
                    titleName = this.titles[key].name;
                }
            }

            if (titleName == 'Geen titel') {
                titleName = '';
            }

            return titleName;
        },
        // loadUsers() {
        //     const params = {
        //         params: {
        //             // user_id: '1'
        //         }
        //     }

        //     const self = this;
        //     axios.get('/darts_db/users/get_enabled_users.php', params).then(function (response) {
        //         console.log(response);

        //         for (let i = 0; i < response.data.length; i++) {
        //             let player = response.data[i];
        //             player.points = -1;

        //             self.players.push(player);

        //         }
        //         self.getPoints();
        //     }).catch(function (error) {
        //         console.log(error);
        //     });
        // },

        // getPoints() {
            

        //     for (let p = 0; p < this.players.length; p++) {
        //         const params = {
        //         params: {
        //                 user_id: this.players[p].id,
        //                 season_id: this.season.id
        //             }
        //         }
        //         const self = this;
        //         axios.get('/darts_db/leaderboard/get_points_by_user_and_season.php', params).then(function (response) {
        //             console.log(response);

                    
        //             for (let i = 0; i < self.players.length; i++) {
                        
        //                 if (self.players[i].id == response.data.id) {

        //                     self.$set(self.players[i], 'points', Number(response.data.points));
        //                 }
        //             }
                    

                    
        //         }).catch(function (error) {
        //             console.log(error);
        //         });

        //     }

            

            
            
        // },

        getActiveSeason() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/seasons/get_active_season.php', params).then(function (response) {
                console.log(response);
                self.season.id = response.data[0].id;
                self.season.name = response.data[0].name;
                // self.loadUsers();
            }).catch(function (error) {
                console.log(error);
            });
            
        },

        getAllPointsForAllSeasons() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/leaderboard/get_all_points_for_all_seasons.php', params).then(function (response) {
                console.log(response);
                self.seasons = response.data;
                for (let i = 0; i < self.seasons.length; i++) {
                    if (self.seasons[i].active == '1') {
                        self.activeSeasonId = self.seasons[i].id // Do I really need this?
                        self.selectedSeason = self.seasons[i];
                    }
                }
                
                
            }).catch(function (error) {
                console.log(error);
            });
        }


    },



    mounted() {
        
        this.getActiveSeason();
        this.getAllPointsForAllSeasons();
        
    }
}
</script>


<style scoped>

    
    


    .piscreen {
        width: 800px;
        background: #444;
        min-height: 480px;
        
    }

    .topBar {

        background: #666;
        display: flex;
        height: 80px;
        /*align-items: center;*/
        /*border-bottom: 1px solid #bbb;*/

        box-shadow: 0px 1px 3px rgba(0,0,0,0.48);

    }
    .home {
        /*position: absolute;*/
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #222;
        margin: 10px 0 10px 10px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #555;
        border-radius: 3px;
        /*height: 60px;*/
        left: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #fff;
    }
    .active a {
        color: gold;
    }

    .leaderboard {
        padding: 10px 10px;
        display: flex;
        justify-content: space-between;
    }

    .leaderboard .scores {
        min-width: 200px;
    }
    table {
        /*border-collapse: collapse;*/
        border: 2px solid #333;
        background: #444;
        color: white;

        /*margin-right: 20px;*/
        /*margin: 15px;*/
    }

    table:nth-child(2) {
        /*margin: 0 auto;*/
        margin-left: auto;
    }

    table:nth-child(2) tr td:nth-child(odd),
    table:nth-child(2) tr td:nth-child(even) {
        background: #444;
    }
    table:nth-child(2) tr:first-child td {
        background: #333;
    }

    table tr {
        /*border-top: 1px solid #bbb;*/
        /*border-bottom: 1px solid #bbb;*/
    }

    table tr td {
        padding: 10px 15px;
        /*height: 35px;*/
    }

    /*table tr td:first-child,
    table tr td:nth-child(2) {
        text-align: center;
    }
    table tr td:nth-child(3) {
        max-width: 160px;
        overflow: hidden;
    }*/
    table tr td:first-child,
    table tr td:nth-child(1) {
        text-align: center;
    }
    table tr td:nth-child(2) {
        max-width: 160px;
        overflow: hidden;
    }


    table tr:nth-child(odd) {
        background: #333;
    }

    table tr td.rankIcon {
        text-align: center;
    }

    .trophy {
        font-size: 28px;
    }

    .star {
        font-size: 20px;
    }

    .gold {
        color: gold;
    }

    .silver {
        color: silver;
    }

    .bronze {
        color: #cd7f32;
    }

    .fade {
        color: #888;
    }

    .smile {
        font-size: 18px;
    }

    .rules {
        /*flex: 1;*/
        /*margin-top: 10px;*/
        /*margin-left: 20px;*/
        /*margin-right: 10px;*/
        /*margin-left: auto;*/
        /*margin-right: auto;*/
        /*width: 440px;*/
        /*margin: 0 auto;*/
        /*padding: 0 10px;*/
        /*background: #666;*/
        color: white;
        /*border: 1px solid #888;*/
        /*box-shadow: 1px 1px 3px rgba(0,0,0,0.24);*/
        padding: 10px;
        max-width: 300px;
    }

    .rules p {
        margin: 0;

    }

    .season {
        padding: 15px 20px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.5);
        margin-bottom: 20px;
        color: white;
        border: 1px solid black;
        margin-bottom: 20px;
        color: white;
        border-radius: 3px;
        background: #333;
        
   
    

    
    
    }

    td.points {
        text-align: center;
    }
    td.points span {
        font-size: 20px;
    }
    td.rank {
        font-size: 20px;
    }

    .activeSeason {
        border: 1px solid gold;
    }
</style>
